import React from "react";
import { connect } from "react-redux";

// import moment from "moment";
import campaignResultDefaultImg from '../../../assets/images/campaignResult-default.png'
import './processingResult.css'
import LeftArrowImg from '../../../assets/images/left-arrow.png'
import RightArrowImg from '../../../assets/images/right-arrow.png'


export class ProcessingResult extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentPage: 1

        }

    }


    getOutboundLogData = () => {

        let sortedArray = this.props.processingLogs.slice(25 * this.state.currentPage - 25, 25 * this.state.currentPage)
        let JSX = [];


        sortedArray.forEach((entry) => {
            JSX.push(<tr className="ProcessingResult-value" key={entry.id}>
                <td className="ProcessingResult-date-value">{entry.InsertedOn.split('.')[0].replace('T', ' ')}</td>
                <td>{entry.ScheduledID}</td>
                <td className="ProcessingResult-description-value">{entry.Description}</td>
            </tr>)
        })

        return JSX;

    }

    moveNextPage = () => {
        if (this.state.currentPage < this.props.maxPage) {
            this.setState({ currentPage: this.state.currentPage + 1 })
        }
    }
    movePreviousPage = () => {
        if (this.state.currentPage > 1) {
            this.setState({ currentPage: this.state.currentPage - 1 })
        }
    }

    conditionalRendering = () => {
        if (this.props.processingLogs) {
            return (<div className="ProcessingResult">

                <div className="ProcessingResult-log-details-container">
                    <table className="ProcessingResult-log-details">
                        <thead>
                            <tr>
                                <th className="ProcessingResult-date">Date</th>
                                <th className="ProcessingResult-schedule">ScheduledID</th>
                                <th className="ProcessingResult-description">Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.getOutboundLogData(this.state.currentPage)}
                        </tbody>
                    </table>
                </div>
                <div className="ProcessingResult-pagination">
                    <div className="ProcessingResult-pagination-count">{this.state.currentPage} of {this.props.maxPage}</div>

                    <div className="ProcessingResult-pagination-buttongroup">
                        <button className="ProcessingResult-pagination-button-previous" onClick={this.movePreviousPage}>
                            <img src={LeftArrowImg} alt="Previous" ></img>
                        </button>
                        <button className="ProcessingResult-pagination-button-next" onClick={this.moveNextPage}>
                            <img src={RightArrowImg} alt="Next" ></img>
                        </button>
                    </div>
                </div>

            </div>)
        } else {
            return (<div className="CampaignResult-default">
                <img src={campaignResultDefaultImg} alt="Default" />
                <div> Let The Search Begin!</div>
            </div>)
        }
    }



    render() {
        return (
            <React.Fragment>
                {this.conditionalRendering()}
            </React.Fragment>

        )
    }
}

const mapStateToProps = (state) => {
    if (state.logs.processingLogs.logs && state.logs.processingLogs.logs.length) {
        //showing 25 entries max per page
        return { processingLogs: state.logs.processingLogs.logs, maxPage: state.logs.processingLogs.logs.length % 25 === 0 ? state.logs.processingLogs.logs.length / 25 : Math.ceil(state.logs.processingLogs.logs.length / 25) };
    } else {
        return { processingLogs: null, maxPage: 1 }
    }
};

export default connect(mapStateToProps)(ProcessingResult);
